/* Floating WhatsApp button - business hours, bottom-corner collision handling, overlay awareness */
(function () {
  const root = document.querySelector("[data-whatsapp-button]");
  if (!root) return;

  const designMode = root.dataset.designMode === "true";

  /* Przeszkody na dole ekranu (pasek ATC, scroll-to-top) fade'ują się opacity,
     a motywowy pasek ATC ma do tego `transition-delay: 1s` — przez tę sekundę
     ma opacity 0, mimo że zaraz się pokaże. Dlatego o widoczności przeszkody
     decyduje visibility + pointer-events, nie opacity: oba motywowe elementy
     wyłączają pointer-events, gdy są schowane. */
  function isObstacleVisible(el) {
    if (!el) return false;
    const style = getComputedStyle(el);
    return (
      style.display !== "none" &&
      style.visibility !== "hidden" &&
      style.pointerEvents !== "none"
    );
  }

  /* Nakładki (pop-up, cookie banner) chowają się klasą albo display/opacity. */
  function isOverlayVisible(el) {
    if (!el) return false;
    const style = getComputedStyle(el);
    return (
      style.display !== "none" &&
      style.visibility !== "hidden" &&
      style.opacity !== "0" &&
      !el.classList.contains("hidden")
    );
  }

  /* ---------- 1. business hours (client side, shop timezone) ---------- */
  const hoursEnabled = root.dataset.hoursEnabled === "true" && !designMode;

  function decimalHourIn(timezone) {
    try {
      const parts = new Intl.DateTimeFormat("en-GB", {
        timeZone: timezone,
        hour: "2-digit",
        minute: "2-digit",
        hourCycle: "h23",
      }).formatToParts(new Date());
      const hour = Number(parts.find((p) => p.type === "hour").value);
      const minute = Number(parts.find((p) => p.type === "minute").value);
      return hour + minute / 60;
    } catch (e) {
      const now = new Date();
      return now.getHours() + now.getMinutes() / 60;
    }
  }

  function isOpen() {
    const from = Number(root.dataset.hoursFrom);
    const to = Number(root.dataset.hoursTo);
    if (!Number.isFinite(from) || !Number.isFinite(to) || from === to) return true;
    const now = decimalHourIn(root.dataset.timezone || "Europe/Warsaw");
    return from < to ? now >= from && now < to : now >= from || now < to;
  }

  function syncHours() {
    root.classList.toggle("wt-whatsapp--closed", !isOpen());
    root.classList.remove("wt-whatsapp--pending");
  }

  if (hoursEnabled) {
    syncHours();
    setInterval(syncHours, 60000);
  } else {
    root.classList.remove("wt-whatsapp--pending");
  }

  /* ---------- 2. stay clear of whatever else sits at the bottom ---------- *
   * sticky "add to cart" bar on the PDP + the theme's scroll-to-top button  */
  const OBSTACLES = ".wt-product__sticky-buy, .wt-scroll-to-top";
  const GAP = 12;
  const BOTTOM_ZONE = 140;

  function baseOffset() {
    return parseFloat(getComputedStyle(root).getPropertyValue("--wa-offset")) || 16;
  }

  function syncLift() {
    const base = baseOffset();
    const self = root.getBoundingClientRect();
    let lift = 0;

    document.querySelectorAll(OBSTACLES).forEach((el) => {
      if (!isObstacleVisible(el)) return;
      const rect = el.getBoundingClientRect();
      if (!rect.height) return;
      /* only elements anchored to the bottom of the viewport can collide */
      if (rect.bottom < window.innerHeight - BOTTOM_ZONE) return;
      /* ...and only if they actually sit under the button horizontally */
      if (rect.right <= self.left || rect.left >= self.right) return;
      lift = Math.max(lift, window.innerHeight - rect.top + GAP - base);
    });

    root.style.setProperty("--wa-lift", Math.max(0, Math.round(lift)) + "px");
  }

  const obstacles = document.querySelectorAll(OBSTACLES);

  if (obstacles.length) {
    obstacles.forEach((el) => {
      new MutationObserver(syncLift).observe(el, {
        attributes: true,
        attributeFilter: ["class", "style"],
      });
      if ("ResizeObserver" in window) new ResizeObserver(syncLift).observe(el);
      el.addEventListener("transitionend", syncLift);
    });
    window.addEventListener("resize", syncLift, { passive: true });
    syncLift();
  }

  /* ---------- 3. step aside for the notification popup / cookie banner ---------- */
  const OVERLAYS = [".not-pu-section", "#shopify-pc__banner", "#shopify-pc__prefs__dialog"];
  const watched = new WeakSet();

  function syncOverlays() {
    const covered = OVERLAYS.some((selector) => isOverlayVisible(document.querySelector(selector)));
    root.classList.toggle("wt-whatsapp--suppressed", covered);
  }

  function watchOverlays() {
    OVERLAYS.forEach((selector) => {
      const el = document.querySelector(selector);
      if (!el || watched.has(el)) return;
      watched.add(el);
      new MutationObserver(syncOverlays).observe(el, {
        attributes: true,
        attributeFilter: ["class", "style", "hidden"],
      });
    });
    syncOverlays();
  }

  watchOverlays();
  /* the cookie banner is injected asynchronously by Shopify */
  new MutationObserver(watchOverlays).observe(document.body, { childList: true });
})();
